var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiogasHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22C1 28.01 6 33 12 33C18 33 23 28.13 23 22C23 15 18 10 18 10C17.79 12.85 17.01 17.35 16 18C16 18 12 16.13 12 10C12 6.25 14 2 14 2C14 2 1 7 1 22Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiogasHeating);
export default __webpack_public_path__ + "static/media/biogasHeating.8e54daa7fafbdcd849e46e84af37901d.svg";
export { ForwardRef as ReactComponent };